import Common from './common'

export default class extends Common {
    init() {
        super.init();
        this.header = document.querySelector('body.home > header');
        this.headerWrapper = document.querySelector('body.home > header .header_wrapper');

        this.calculateHeaderSizes();

        window.addEventListener('resize', () => {
            this.calculateHeaderSizes();
            this.header.style.height = window.innerHeight + 'px';
            this.calculateHeaderContentSises();
        });

        window.addEventListener('scroll', this.calculateHeaderContentSises.bind(this));

        let navLinks = document.querySelectorAll('nav#mobile a, nav#main a');

        Array.from(navLinks).forEach((link) => {
            let startPosition = link.href.indexOf(location.host) + location.host.length ;
            let path = link.href.substr(startPosition);

            let id = path.replace('/', '');
            const element = document.getElementById(id);

            if (element) {

                if (path == window.location.pathname) {
                    setTimeout(() => this.goToPageUrl(path, element), 500);
                }

                link.addEventListener('click', (event) => this.goToPageUrl(path, element, event));
            }
        });

        let showMoreButton = document.getElementById('show_more');
        showMoreButton.addEventListener('click', () => {
            let rows = document.querySelectorAll('#projects .three-column:not(.active)');
            if (rows.length) {

                if (!rows[0].classList.contains('active')) {
                    rows[0].classList.add('active');
                }
            }
            if (document.querySelectorAll('#projects .three-column:not(.active)').length === 0) {
                showMoreButton.classList.add('hidden');
            }
        });
    }

    /**
     *
     * @param path
     * @param element
     * @param event
     */
    goToPageUrl(path, element, event = null) {
        if (event) {
            event.preventDefault();
        }

        if (window.location.pathname !== path) {
            window.history.pushState({}, "", path);
        }

        this.scrollToElement(element);
    }

    /**
     * Scrolls to a page element properly
     * @param element
     */
    scrollToElement(element) {

        if (this.mobileMenuToggle.classList.contains('is-active')) {
            this.toggleMenu();
        }

        let to = element.offsetTop - this.minimumHeaderHeight;
        window.scrollTo({
            top: to,
            behavior: "smooth",
        });
    }

    /**
     * Calculates needed header sizes
     */
    calculateHeaderSizes() {
        this.maximumHeaderHeight = window.innerHeight;
        this.minimumHeaderHeight = this.maximumHeaderHeight * .15 < 160 ?
                  160 : this.maximumHeaderHeight * .15 ;
    }

    pastHeader() {
        return window.innerHeight - this.minimumHeaderHeight < window.scrollY;
    }

    calculateHeaderContentSises() {
        if (this.pastHeader()) {
            this.headerWrapper.style.height = this.minimumHeaderHeight + 'px';
        } else {
            this.headerWrapper.style.height = (window.innerHeight - window.scrollY) + 'px';
        }
    }

    finalize() {
      // JavaScript to be fired on the home page, after the init JS
    }
};



// WEBPACK FOOTER //
// ./app/resources/js/routes/home.js